import { AppContainerComponent } from './components/app-container/app-container.component';
import { BoxContainerWithHeaderComponent } from './components/box-container-with-header/box-container-with-header.component';
import { BoxContainerWithTitleComponent } from './components/box-container-with-title/box-container-with-title.component';
import { BoxContainerComponent } from './components/box-container/box-container.component';
import { BoxSectionComponent } from './components/box-section/box-section.component';
import { EditEmailComponent } from './components/edit-email/edit-email.component';
import { ErrorBoxComponent } from './components/error-box/error-box.component';
import { ItemsNavComponent } from './components/items-nav/items-nav.component';
import { LoginCommonComponent } from './components/login-common/login-common.component';
import { LoginContainerComponent } from './components/login-container/login-container.component';
import { PasswordChangeDialogComponent } from './components/password-change-dialog/password-change-dialog.component';
import { PasswordChangeComponent } from './components/password-change/password-change.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthModule } from '@ppl/auth';
import { CoreModule as PplCoreModule } from '@ppl/core';
import { I18nModule } from '@ppl/i18n';
import { PplAvatarModule } from '@ppl/ui/avatar';
import { PplButtonModule } from '@ppl/ui/button';
import { PplCheckboxModule } from '@ppl/ui/checkbox';
import { PplDialogModule } from '@ppl/ui/dialog';
import { PplFormModule } from '@ppl/ui/form';
import { PplIconModule } from '@ppl/ui/icon';
import { PplInfoBoxModule } from '@ppl/ui/info-box';
import { PplInputModule } from '@ppl/ui/input';
import { PplLinkModule } from '@ppl/ui/link';
import { PplLoadingModule } from '@ppl/ui/loading';

const MODULE_COMPONENTS = [
  AppContainerComponent,
  BoxContainerComponent,
  BoxContainerWithHeaderComponent,
  BoxContainerWithTitleComponent,
  BoxSectionComponent,
  PasswordChangeComponent,
  ErrorBoxComponent,
  ItemsNavComponent,
  PasswordChangeDialogComponent,
  LoginContainerComponent,
  LoginCommonComponent,
  EditEmailComponent
];

const SHARED_NG_UI_MODULES = [
  PplIconModule,
  PplCheckboxModule,
  PplFormModule,
  PplInputModule,
  PplDialogModule,
  PplInfoBoxModule,
  PplIconModule,
  PplLinkModule,
  PplLoadingModule,
  PplButtonModule,
  PplAvatarModule
];

@NgModule({
  imports: [
    CommonModule,
    PplCoreModule,
    I18nModule,
    ReactiveFormsModule,
    RouterModule,
    AuthModule,
    ...SHARED_NG_UI_MODULES
  ],
  declarations: [
    ...MODULE_COMPONENTS
  ],
  exports: [
    ...MODULE_COMPONENTS,
    ...SHARED_NG_UI_MODULES,
    PplCoreModule,
    I18nModule,
    AuthModule
  ]
})
export class SharedModule { }
